import React, { useEffect, useState } from 'react'
import Header from '../heade_foot/header'
import Footer from '../heade_foot/footer'
import { Outlet } from 'react-router-dom'
//import "../config/handleNotification"
import Notifications from "../Notifications/Notification";
import ReactNotificationComponent from "../Notifications/ReactNotification";
import { getMessaging, onMessage } from "firebase/messaging";
import "../styles/main.css"

export default function Main({propsData,unread}) {
  const [show, setShow] = useState(false);
  const [notification, setNotification] = useState({ title: "", body: "" });

 // console.log(show, notification);
  const messaging = getMessaging();
  useEffect(() => {
    // Handle foreground messages
    onMessage(messaging, (payload) => {
      // console.log(payload);
       if(payload.notification){
         setShow(true);
         setNotification({
          title: payload.notification.title,
          body: payload.notification.body,
        });
       }
    });
    
    // Cleanup
    return () => {
      onMessage(messaging);
    };
  }, []);

  return (
    <div className='main'>
       <div ><Header unread={unread} userData={propsData.userData} allShopes={propsData.userShope} handleCurrentShope={propsData.handleCurrentShope} currentShope={propsData.currentShope}/></div>
       {show ? (
        <ReactNotificationComponent
          title={notification.title}
          body={notification.body}
          setShow={setShow}
          setNotification={setNotification}
        />
      ) : (
        <></>
      )}
      <Notifications propsData={propsData}/>
        <div style={{marginTop:"53px"}}><Outlet/></div>
       {/* <div><Footer/></div>*/}
    </div>
  )
}
